// extracted by mini-css-extract-plugin
export default {"profile":"profile_profile__Evbmz","content":"profile_content__behti","submit_container":"profile_submit_container__dLDoz"};